var exports = {
  "$P": "StreamSettingsMenuContent.module__modeItem___WWgtai",
  "Q6": "StreamSettingsMenuContent.module__modeLabelColumn___WWgtai",
  "i2": "StreamSettingsMenuContent.module__modeTitle___WWgtai",
  "ED": "StreamSettingsMenuContent.module__modeDescription___WWgtai",
  "nM": "StreamSettingsMenuContent.module__row___WWgtai",
  "xZ": "StreamSettingsMenuContent.module__rowLabel___WWgtai",
  "BE": "StreamSettingsMenuContent.module__premiumBadge___WWgtai",
  "JV": "StreamSettingsMenuContent.module__audioDeviceLabel___WWgtai",
  "ue": "StreamSettingsMenuContent.module__audioDeviceName___WWgtai",
  "Ky": "StreamSettingsMenuContent.module__audioDeviceSubtext___WWgtai",
  "HA": "StreamSettingsMenuContent.module__compactLiveGroupLabel___WWgtai",
  "Au": "StreamSettingsMenuContent.module__audioDeviceIcon___WWgtai",
};

module.exports = exports;
